module.exports = __webpack_public_path__ + "img/FirstWarning.49689977.jpg";